import { Colors, Lightning } from "@lightningjs/sdk";
import { MovieDetailsCover } from "./MovieDetailsCover";
import { MediaDurationWithProgress } from "../../../pages/vod/components/MediaDurationWithProgress/MediaDurationWithProgress";
import { MediaActions } from "../../../pages/vod/components/MediaActions/MediaActions";
import theme from "../../../lib/theme";
import { formatTime, MENU_WIDTH_ACTIVE } from "../../../lib/utils";
import { MediaModel } from "../../../lib/models";
import { TranslatableText } from "../TranslatableText/TranslatableText";
import { themeManager } from "../../configurations/Theme/ThemeManager";

interface MovieFullScreenTemplateSpec extends Lightning.Component.TemplateSpec {
    data: MediaModel;
    coverSize: {
        w: number;
        h: number;
    };

    Cover: typeof MovieDetailsCover;
    Top: {
        MainInfo: {
            BaseInfo: {
                Info: {
                    Name: object;
                    SeriesMeta: typeof TranslatableText;
                    Labels: {
                        Year: typeof Object;
                        Duration: typeof TranslatableText;
                        Rating: typeof Object;
                        Resolution: typeof Object;
                    };
                };
            };
            EpisodeInfo: object;
            Description: object;
            Languages: {
                Label: {
                    Text: typeof TranslatableText;
                };
                Languages: object;
            };
            Subtitles: {
                Label: typeof TranslatableText;
                Languages: object;
            };
        };
        Buttons: typeof MediaActions;
    };
}

export class MovieFullScreen
    extends Lightning.Component<MovieFullScreenTemplateSpec>
    implements Lightning.Component.ImplementTemplateSpec<MovieFullScreenTemplateSpec>
{
    _boundEventHandler?: any;

    static override _template(): Lightning.Component.Template<MovieFullScreenTemplateSpec> {
        return {
            collision: true,
            w: theme.layout.w - MENU_WIDTH_ACTIVE - theme.layout.content.x,
            h: theme.layout.h,
            x: MENU_WIDTH_ACTIVE + theme.layout.content.x,
            // h: (h) => h,
            // x: (w) => w / 2,
            // mountX: 0.5,
            flex: { direction: "row", justifyContent: "flex-start", alignItems: "center" },
            Cover: {
                type: MovieDetailsCover,
                h: 736,
                w: 552
            },
            Top: {
                collision: true,
                y: 0,
                w: 950,
                h: 606,
                // h: (h) => h,
                flex: { direction: "column", justifyContent: "space-between" },
                MainInfo: {
                    flex: { direction: "column" },
                    BaseInfo: {
                        w: (w) => w,
                        flex: { direction: "row", justifyContent: "flex-start" },
                        Info: {
                            flex: { direction: "column", justifyContent: "center" },
                            Name: {
                                flexItem: { marginBottom: 8 },
                                w: theme.movie.content.w - theme.mediaItem.w - 34,
                                text: {
                                    text: "",
                                    fontSize: 40,
                                    lineHeight: 50,
                                    textOverflow: "ellipsis",
                                    fontFace: "Semibold",
                                    wordWrap: true,
                                    maxLines: 3
                                }
                            },
                            SeriesMeta: {
                                type: TranslatableText,
                                w: theme.movie.content.w - theme.mediaItem.w - 34,
                                text: {
                                    text: "",
                                    fontSize: 20,
                                    lineHeight: 20,
                                    fontFace: "Semibold"
                                }
                            },
                            Labels: {
                                flex: { direction: "row" },
                                flexItem: { marginBottom: 10 },
                                Year: {
                                    text: {
                                        text: "",
                                        fontSize: 20,
                                        wordWrap: true,
                                        lineHeight: 20,
                                        fontFace: "SemiBold"
                                    }
                                },
                                Duration: {
                                    type: TranslatableText,
                                    text: {
                                        text: "",
                                        fontSize: 20,
                                        wordWrap: true,
                                        lineHeight: 20,
                                        fontFace: "SemiBold"
                                    }
                                },
                                Rating: {
                                    text: {
                                        text: "",
                                        fontSize: 20,
                                        wordWrap: true,
                                        lineHeight: 20,
                                        fontFace: "SemiBold"
                                    }
                                },
                                Resolution: {
                                    text: {
                                        text: "",
                                        fontSize: 20,
                                        wordWrap: true,
                                        lineHeight: 20,
                                        fontFace: "SemiBold"
                                    }
                                }
                            }
                        }
                    },
                    EpisodeInfo: {
                        alpha: 0,
                        w: 950,
                        text: {
                            text: "",
                            fontSize: 20,
                            lineHeight: 28,
                            textOverflow: "ellipsis",
                            wordWrap: true,
                            maxLines: 2,
                            fontFace: "Semibold",
                            textColor: Colors(theme.colors.text.primary).get()
                        }
                    },
                    Description: {
                        flexItem: { marginTop: 24 },
                        w: 950,
                        text: {
                            text: "",
                            fontSize: 20,
                            lineHeight: 28,
                            textOverflow: "ellipsis",
                            wordWrap: true,
                            maxLines: 8,
                            textColor: Colors(theme.colors.text.primary).get()
                        }
                    },
                    Languages: {},
                    Subtitles: {}
                },
                Buttons: {
                    h: 60,
                    flexItem: { marginTop: 24 },
                    type: MediaActions
                    // hasPlay: true
                }
            }
        };
    }

    readonly Cover = this.getByRef("Cover")!;
    readonly Top = this.getByRef("Top")!;
    readonly Buttons = this.Top.getByRef("Buttons")!;

    readonly MainInfo = this.Top.getByRef("MainInfo")!;
    readonly BaseInfo = this.MainInfo.getByRef("BaseInfo")!;
    readonly Info = this.BaseInfo.getByRef("Info")!;
    readonly Name = this.Info.getByRef("Name")!;
    readonly SeriesMeta = this.Info.getByRef("SeriesMeta")!;
    readonly Labels = this.Info.getByRef("Labels")!;
    readonly Duration = this.Labels.getByRef("Duration")!;
    readonly Year = this.Labels.getByRef("Year")!;
    readonly Resolution = this.Labels.getByRef("Resolution")!;
    readonly Rating = this.Labels.getByRef("Rating")!;
    readonly EpisodeInfo = this.MainInfo.getByRef("EpisodeInfo")!;
    readonly Description = this.MainInfo.getByRef("Description")!;
    readonly Languages = this.MainInfo.getByRef("Languages")!;
    readonly Subtitles = this.MainInfo.getByRef("Subtitles")!;

    set coverSize(value: { w: number; h: number }) {
        this.Cover.patch(value);
        this.Top.patch({
            h: value.h - 70
        });
    }

    override _setup() {
        this._boundEventHandler = this._update.bind(this);
    }

    override _active() {
        this.application.on("updateSelectedMovie", this._boundEventHandler);
    }

    override _inactive() {
        this.application.off("updateSelectedMovie", this._boundEventHandler);
    }

    _renderLanguageSection(container: any, labelKey: string, items: string[]) {
        if (!items?.length) return;

        container.patch({
            flex: { direction: "row", alignItems: "center" },
            flexItem: {
                // marginBottom: 10,
                marginTop: 10
            },
            Label: {
                w: 180,
                Text: {
                    mountY: 0.5,
                    y: (y: number) => y / 2,
                    type: TranslatableText,
                    key: labelKey,
                    text: {
                        fontSize: 20,
                        wordWrap: true,
                        lineHeight: 20,
                        fontFace: "SemiBold"
                    }
                }
            },
            Languages: { w: 850, flex: { direction: "row", wrap: true } }
        });

        container.getByRef("Languages")!.children = items.map((item) => ({
            w: 130,
            h: 43,
            flexItem: {
                marginRight: 20
                // marginBottom: 20
            },
            texture: Lightning.Tools.getRoundRect(130, 43, 10, 1, Colors(theme.colors.text.primary).get(), false),
            Text: {
                mount: 0.5,
                x: (w: number) => w / 2,
                y: (y: number) => y / 2,
                text: {
                    text: item,
                    fontSize: 20,
                    wordWrap: true,
                    lineHeight: 20,
                    fontFace: "SemiBold",
                    textAlign: "center"
                }
            }
        }));
    }

    _update(movie: MediaModel) {
        console.log("UPDATE", movie);

        this.Buttons.patch({
            hasPlay: movie.__typename === "Movie" || movie.__typename === "Episode" || movie.__typename === "LiveStream"
        });

        if (movie.seasonCount) {
            this.SeriesMeta.patch({
                translate: {
                    key: "metadata.seasonCount",
                    value: movie.seasonCount.toString()
                },
                flexItem: { marginBottom: 10 }
            });
        } else {
            this.SeriesMeta.patch({
                text: {
                    text: ""
                },
                flexItem: { marginBottom: 0 }
            });
        }

        this.Cover?.patch({
            textureSrc: movie.coverUrl
        });

        this.Name.patch({
            text: {
                text: movie.season?.series?.title || movie?.series?.title || movie.title || ""
            }
        });

        console.log("movie", movie);
        // Show episode info only for episodes
        if (movie.__typename === "TvSeries") {
            const seasonNumber = movie.season?.seasonNumber?.toString() || movie.seasonNumber?.toString() || "";
            const episodeNumber = movie.episodeNumber?.toString() || "";
            const season = seasonNumber ? "S" + (seasonNumber.length === 1 ? "0" : "") + seasonNumber : "";
            const episode = episodeNumber ? "E" + (episodeNumber.length === 1 ? "0" : "") + episodeNumber : "";
            const episodeLabel = season + episode;
            // const episodeLabel = episode;
            const episodeTitle = movie.title || "";
            const episodeText = episodeLabel ? `${episodeLabel}: ${episodeTitle}` : episodeTitle;

            this.EpisodeInfo.patch({
                alpha: 1,
                flexItem: { marginTop: 16 },
                text: {
                    text: episodeText
                }
            });
        } else {
            this.EpisodeInfo.patch({
                alpha: 0,
                text: {
                    text: ""
                }
            });
        }

        this.Description.patch({
            text: {
                text: movie.description || ""
            }
        });

        const year = movie.releaseYear?.toString() || "";
        const rating = movie.fsk;
        const resolution = movie.resolution?.join(", ");

        let nextValue = !!year || !!rating || !!resolution;
        if (movie.duration) {
            this.Duration.patch({
                translate: {
                    key: "metadata.duration",
                    value: formatTime(movie.duration) + (!!movie.duration && nextValue ? "  •" : "")
                },
                flexItem: { marginRight: 10 }
            });
        } else {
            this.Duration.patch({
                translate: {
                    key: "",
                    value: ""
                },
                text: {
                    text: ""
                },
                flexItem: { marginRight: 0 }
            });
        }

        nextValue = !!rating || !!resolution;
        this.Year.patch({
            text: {
                text: year + (!!year && nextValue ? "  •" : "")
            },
            flexItem: { marginRight: !!year && nextValue ? 10 : 0 }
        });

        nextValue = !!resolution;
        this.Rating.patch({
            text: {
                text: (rating?.toString() || "") + (rating ? "+" : "") + (nextValue && !!rating ? "  •" : "")
            },
            flexItem: { marginRight: rating && nextValue ? 10 : 0 }
        });

        // nextValue = nextValue || !!rating;
        this.Resolution.patch({
            text: {
                text: resolution || ""
            }
            // flexItem: { marginRight: nextValue ? 10 : 0 }
        });

        this.Buttons.patch({
            data: movie
        });

        this._renderLanguageSection(this.Languages, "settings.popup.audioMenuTitle", movie.languages || []);
        this._renderLanguageSection(this.Subtitles, "settings.popup.subtitleMenuTitle", movie.subtitles || []);
    }

    set data(movie: MediaModel) {
        this._update(movie);
    }

    override _getFocused() {
        return this.Buttons;
    }
}
